export const UpravljanjeKorisnicimaResourcesBS: UpravljanjeKorisnicimaResourcesBSInterface =
  {
    dupplicateError: "Dodavanje nije uspjelo, uneseni podatci su duplicirani",
    upravljanjeKorisnicima: {
      title: "Upravljanje korisnicima",
      dropdownLabel: "Odabir korisnika:",
      dropdownPlaceholder: "Odaberite korisnika sa liste",
      dropdownNoOptionsMessage: "Nema podataka",
      addCompanyButton: "Dodaj korisnika",
      next: "Odaberi",
      back: "Nazad",
    },
    UKPPK: {
      title: "Upravljanje Korisnicima Provjer a Podataka Korisnika",
      addCompanyButton: "Dodaj kompaniju",
      addUserPosition: "Dodaj radno mjesto",
      addRecord: "Dodaj evidenciju",
      branch: "Poslovnica: ",
      address: "Adresa: ",
      position: "Radno mijesto: ",
    },
    branchManagement: {
      currentBranches: "Trenutne poslovnice za",
      noBranchesAssigned: "Nema dodijeljenih poslovnica za ovog korisnika.",
      availableBranches: "Dostupne poslovnice",
      addBranch: "Dodaj poslovnicu",
      hide: "Sakrij",
      remove: "Ukloni",
      add: "Dodaj",
      noAvailableBranches: "Nema dostupnih poslovnica za dodavanje.",
      loading: "Učitavanje...",
      error: "Greška:",
    },
    menuAccessRights: {
      title: "Prava pristupa meniju za",
      saveButton: "Spremi promjene",
      description:
        "Odaberite ekrane koje korisnik može vidjeti u meniju. Možete dodavati ili uklanjati stavke za svaku kategoriju.",
      selectPlaceholder: "Odaberite ekrane...",
      noOptions: "Nema dostupnih opcija",
      updateError: "Greška pri ažuriranju prava pristupa.",
    },
    managerChief: {
      titleManager: "Menadžer u poslovnicama",
      titleChief: "Šef u kompanijama",
      noManagers: "Korisnik nije dodijeljen kao menadžer nijednoj poslovnici.",
      noChiefs: "Korisnik nije dodijeljen kao šef nijednoj kompaniji.",
    },
    contractedHours: {
      title: "Ugovoreni radni sati",
      label: "Sedmični sati",
      hint: "Podrazumijevano 40 sati sedmično. U sihtarici se prikazuje prekoračenje ako radnik u kalendarskoj sedmici (pon–ned) premaši ovaj broj.",
      save: "Sačuvaj",
      saving: "Čuvanje...",
      saved: "Ugovoreni sati su sačuvani.",
      error: "Greška pri čuvanju ugovorenih sati.",
      invalid: "Unesite validan broj sati (1–168).",
      noPermission:
        "Samo menadžer, šef ili admin mogu mijenjati ugovorene sate.",
    },
  };

export interface UpravljanjeKorisnicimaResourcesBSInterface {
  dupplicateError: string;
  upravljanjeKorisnicima: {
    title: string;
    dropdownLabel: string;
    dropdownPlaceholder: string;
    dropdownNoOptionsMessage: string;
    addCompanyButton: string;
    next: string;
    back: string;
  };
  UKPPK: {
    title: string;
    addCompanyButton: string;
    addUserPosition: string;
    addRecord: string;
    branch: string;
    address: string;
    position: string;
  };
  branchManagement: {
    currentBranches: string;
    noBranchesAssigned: string;
    availableBranches: string;
    addBranch: string;
    hide: string;
    remove: string;
    add: string;
    noAvailableBranches: string;
    loading: string;
    error: string;
  };
  menuAccessRights: {
    title: string;
    saveButton: string;
    description: string;
    selectPlaceholder: string;
    noOptions: string;
    updateError: string;
  };
  managerChief: {
    titleManager: string;
    titleChief: string;
    noManagers: string;
    noChiefs: string;
  };
  contractedHours: {
    title: string;
    label: string;
    hint: string;
    save: string;
    saving: string;
    saved: string;
    error: string;
    invalid: string;
    noPermission: string;
  };
}
